import React from 'react';
import ReactDOM from "react-dom";
import _ from 'root/libs/exaforte/react/lodash';
import Config from 'root/globals/Config';
import Components from 'root/Components';
import { View, Text, ActivityIndicator, Image, Link } from 'react-native';
import { Swiper, SwiperSlide } from 'swiper/react';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import { openUserPage, getUserPicture } from 'root/globals/Functions';
import Menu from 'root/globals/views/Menu';
import { EditMenu } from 'root/globals/views/CustomOverview';
import Toast from 'react-bootstrap/Toast';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { ContentDialog } from 'root/globals/Dialog';
import Collapse from "@material-ui/core/Collapse";
import Model from 'root/libs/exaforte/react/Model';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import CustomForm from 'root/libs/exaforte/react/form/CustomForm';
import { CustomSelect } from 'root/libs/exaforte/react/Form';
import FontAwesomeIcon from 'root/libs/exaforte/react/FontAwesomeIcon';
import moment from 'moment';

import { faEllipsisV, faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faInfoCircle, faCalendarDay, faUpload, faPaperPlane, faBuilding, faClipboardList, faFileAlt, faFileInvoice, faUserClock, faCloudDownloadAlt, faCar, faTrash, faCheck, faLock } from '@fortawesome/pro-light-svg-icons';


import DocumentItem from 'root/globals/document/DocumentItem';
import DocumentDialog from 'root/globals/document/Document View';

import 'swiper/swiper.min.css';
import defaults from 'root/globals/Defaults.less';
import elements from './Elements.less';

const styles = {...defaults, ...elements};

export class Container extends React.Component {
    render() {
        return <View className={['container', ...(this.props.className || [])]}>
            {this.props.children}
        </View>;
    }
}

export class CustomBlock extends React.Component {
    render() {
        return <BlockView className={this.props.className} {...(this.props.color ? {color: this.props.color} : {})}>
            {!_.is_empty(this.props.headContent) && this.props.headContent}
            {(!_.is_empty(this.props.title) || !_.is_empty(this.props.actions)) && <View className={['align-items-center justify-content-between d-flex mb-4']} {...(this.props.titleMinHeight > 0 && {style: {minHeight: this.props.titleMinHeight}})}>
                {this.props.title && <BlockViewTitle description={this.props.description}>{this.props.title}</BlockViewTitle>}
                {this.props.actions && <View className={'d-flex'}>{this.props.actions}</View>}
            </View>}
            {this.props.children}
        </BlockView>;
    }
}

CustomBlock.defaultProps = {
    titleMinHeight: 37
}

export class CustomerBlock extends CustomComponent {
    render() {
        return (
            <View className={['d-flex flex-row align-items-center']}>
                <View className={['d-none d-xl-block mr-2']}>{getUserPicture(this.props.user, this.props.size)}</View>
                <Text className={[styles['text-ellipsis']]}>{this.props.user.title}</Text>
            </View>
        );
    }
}

CustomerBlock.defaultProps = {
    size: 'small'
}

export class BasicBlockView extends React.Component {
    render() {
        return <View className={[...[styles['background-color-' + (this.props.color || 'white')], ...(this.props.className && this.props.className.includes(styles['b-0']) ? [] : [styles['b-1'], styles['border-color-light-grey']])], ...(this.props.className || [])]}>
        	{this.props.children}
		</View>;
    }
}

export class BlockView extends React.Component {
    render() {
        return <BasicBlockView className={[...['col-12 p-4'], ...(this.props.className || [])]}>
        	{this.props.children}
		</BasicBlockView>;
    }
}

export class BlockViewTitle extends React.Component {
    render() {
        let title = <Text className={[styles['f-2-2-5'], styles['font-montserrat'], styles['text-bold'], styles['text-ellipsis'], ...(this.props.className || [])]}>{this.props.children}</Text>;
        
        if(this.props.description)
            return (
                <View>
                    {title}
                    <Text className={[styles['f-1-5'], styles['font-montserrat'], styles['text-light'], styles['color-black']]}>{this.props.description}</Text>
                </View>
            );
        
        return title;
    }
}

export class ButtonGroup extends React.Component {
    render() {
        return <>
            {this.props.breakpoint !== false && <View className={['d-flex d-' + this.props.breakpoint + '-none']}>
                <Menu items={this.props.buttons} id={this.props.id}>
                    <FontAwesomeIcon icon={faEllipsisV} className={styles['f-3']} />
                </Menu>
            </View>}
            <View className={[(this.props.breakpoint !== false ? 'd-none d-' + this.props.breakpoint + '-flex' : 'd-flex')]}>
                {_.map(this.props.buttons, (button, index) => <Button key={'button-group-' + this.props.id + '-' + index} {...button}>{button.title}</Button>)}
            </View>
        </>;
    }
}

ButtonGroup.defaultProps = {
    breakpoint: 'lg'
}

export class ConfirmDialog extends CustomComponent {
    render() {
        return (
            <ContentDialog maxWidth={'sm'} title={this.props.title || 'Let op!'}>
                <Text className={[styles['color-dark-grey'], styles['f-1-7-5'], styles['text-light']]}>{this.props.message}</Text>
                <View className={['flex-row d-flex justify-content-end mt-4 pt-4', styles['border-color-light-grey'], styles['bt-1']]}>
                    <Button secondary={true} onPress={this.props.onDecline}>Nee, toch maar niet</Button>
                    <Button onPress={this.props.onConfirm} className={['ml-2']}>Ja, doe maar</Button>
                </View>
            </ContentDialog>
        );
    }
}

export class ConfirmTouchableArea extends React.Component {
    constructor(props) {
        super(props);
        
        this.state      = {showConfirm: false, confirmed: false};
        this.onPress    = this.onPress.bind(this);
        this.decline    = this.decline.bind(this);
        this.confirm    = this.confirm.bind(this);
    }
    
    decline(e) {
        if(this.props.stopPropagation === true && e.stopPropagation)
            e.stopPropagation();
        
        this.setState({showConfirm: false});
    }
    
    confirm(e) {
        if(this.props.stopPropagation === true && e.stopPropagation)
            e.stopPropagation();
        
        this.setState({showConfirm: false, confirmed: true}, () => {
            if(this.props.onPressWithEvent === false)
                this.props.onPress(this.props.onPressParams);
            else
                this.props.onPress(e, this.props.onPressParams);
        });
    }
    
    onPress(e) {
        if(this.props.stopPropagation === true && e.stopPropagation)
            e.stopPropagation();
        
        if(this.props.confirmMessage && !this.state.confirmed && !this.state.showConfirm)
            this.setState({showConfirm: true, confirmed: false});
        else if(this.props.onPressWithEvent === false)
            this.props.onPress(this.props.onPressParams);
        else
            this.props.onPress(e, this.props.onPressParams);
    }
    
    render() {
        if(!this.props.onPress)
            return <View {..._.omit(this.props, ['confirmMessage'])} />;
        
        return <>
            {this.state.showConfirm && <ConfirmDialog title={this.props.confirmTitle} message={this.props.confirmMessage} onConfirm={this.confirm} onDecline={this.decline} />}
            <TouchableArea onPress={this.onPress} {..._.omit(this.props, ['onPress', 'confirmMessage'])}>{this.props.children}</TouchableArea>
        </>;
    }
}

export class Button extends React.Component {
    render() {
        return <ConfirmTouchableArea className={[styles['button'], styles['b-1'], ...(this.props.px != null ? [styles['px-' + this.props.px]] : []), , ...(this.props.py != null ? [styles['py-' + this.props.py]] : []), styles['border-color-' + this.props.color], styles[(this.props.secondary ? 'background-color-white' : 'background-color-' + this.props.color)], styles['f-1-2-5'], styles[(this.props.secondary ? 'color-' + this.props.color : 'color-white')], 'justify-content-center align-items-center', (this.props.disabled || this.props.loading ? 'button-disabled' : ''), (this.props.disabled || this.props.loading ? 'button-loading' : ''), ...(this.props.className || '')]} {...{...(this.props.disabled || this.props.loading ? {} : {onPress: this.props.onPress}), ..._.omit(this.props, ['onPress', 'className', 'secondary', 'disabled', 'loading', 'color'])}}>
            {this.props.loading && <ActivityIndicator className={['mr-2']} />}
            {this.props.children}
        </ConfirmTouchableArea>;
    }
}

Button.defaultProps = {
    color: 'light-blue',
    px: '2',
    py: '1'
}

export function Status({ status, color, size, className })
{
    return (
        <View className={['d-flex flex-row align-items-center']}>
            <StatusDot color={color} size={size} />
            <Text className={['ml-1', styles['text-ellipsis'], ...(className || [])]}>{status}</Text>
        </View>
    );
}

export function Ribbon({ title, color = 'blue', position, flipped, className })
{
    if(position == 'top')
        return <View className={[...['d-inline-flex px-4 align-items-center', styles['view-top-flag'], styles['background-color-' + color]], ...(className || [])]}>
            <Text className={[styles['text-light'], 'text-center width-hunderd']}>{title}</Text>
        </View>;
        
    return <View className={[...['d-inline-flex px-4 align-items-center', styles['view-flag'], styles['background-color-' + color], ...(flipped ? [styles['view-flag-flipped']] : [])], ...(className || [])]}>
        <Text className={[styles['text-light'], 'text-center width-hunderd']}>{title}</Text>
    </View>;
}

export function UserBlock({ icon, user, size = 'small', title, subtitle, subtitleClassNames, onPress, pages, tabs, params })
{
    if(!onPress && pages)
        onPress = () => openUserPage({ pages, user, params, tabs });
    
    return (
        <TouchableArea className={[styles['text-ellipsis'], 'd-flex align-items-center']} onPress={onPress} onPressParams={user} onPressWithEvent={false}>
            {icon ? <FontAwesomeIcon icon={icon} className={[styles['f-3-2-5']].join(' ')} /> : (user ? getUserPicture(user, size) : null)}
	        <View className={[styles['text-ellipsis'], ...((icon || user) ? ['ml-2 pl-1'] : [])]}>
                <Text className={[styles['f-' + (size == 'smallest' ? '1-2-5' : '1-7-5')], styles['text-ellipsis'], styles['line-height-' + (size == 'smallest' ? '1' : '1-5')]]}>{title || user.display_name}</Text>
                <Text className={[...[styles['f-' + (size == 'smallest' ? '1' : '1-5')], styles['text-ellipsis'], styles['text-light'], styles['line-height-' + (size == 'smallest' ? '0-5' : '1')]], ...(subtitleClassNames || [styles['color-dark-grey']])]}>{subtitle}</Text>
            </View>
        </TouchableArea>
    );
}

export class CustomToast extends React.Component{
    render(){
        return <Toast className={['fixed-top', styles['toast']]} style={this.props.style} onClose={this.props.onClose} show={this.props.show_toast} delay={10000} autohide>
            <Toast.Header>
                <View className={['d-flex flex-row align-items-center', styles['pt-0-5'], styles['pb-1']]}>
                    <View className={['p-3 mr-2 rounded-circle', styles['background-color-' + this.props.color]]}>
                        {this.props.icon}
                    </View>
                    <Text className={['pr-1', styles['font-montserrat'], styles['f-1-7-5'], styles['text-bold'], styles['color-black']]}>{this.props.title}</Text>
                </View>
            </Toast.Header>
            <ProgressBar className={['mt-n1 rounded-0', styles['progress-bar']]} now={100} variant={this.props.variant} />
         </Toast>;
    }
}

CustomToast.defaultProps = {
    color: 'mint-blue-10',
    variant: 'success'
}

export class StackedCustomToasts extends CustomComponent {
    constructor(props) {
        super(props);
        
        this.heights = [];
    }
    
    _addHeight(ref, index) {
        let dom = ReactDOM.findDOMNode(ref);
        
        if(dom)
            this.heights.splice(index, 0, dom.offsetHeight);
    }
    
    _onClose(index) {
        this.heights.splice(index, 1);
        
        this.props.removeFromStack(index);
    }
    
    _renderToast(toast, index) {
        let key         = toast.index || index;
        let marginTop   = 0;
        
        for(let i = 0; i < this.heights.length; i++)
        {
            if(i >= index)
                break;
            
            marginTop += this.heights[i] + 20;
        }
        
        return <CustomToast {..._.omit(toast, ['show_toast', 'onClose'])} style={{ marginTop }} show_toast={true} onClose={this.props.removeFromStack ? () => this._onClose(index) : undefined} key={key} ref={ref => this._addHeight(ref, index)} />;
    }
    
    render() {
        if(_.is_empty(this.props.toasts))
            return null;
        
        return _.map(this.props.toasts, this._renderToast);
    }
}

export class StatusDot extends React.Component {
    render() {
        return <View className={[styles['dot' + (!_.is_empty(this.props.size) ? '-' + this.props.size : '')], styles['border-radius-100'], styles['background-color-' + this.props.color], 'mr-2']}></View>;
    }
}

StatusDot.defaultProps = {
    color: 'black',
    size: 'sm',
}

export class InstructionBox extends CustomComponent{
    constructor(props) {
        super(props)
        
        this.state = {show_more: false, show_more_animation: false, selected_document: null, show_document_dialog: false};
    }
    
    _toggle_animation(){
        if(this.state.show_more && this.state.show_more_animation)
            this.setState({show_more_animation: false})
        else{
            this.setState({show_more: true})
            this.setState({show_more_animation: true})
        }
    }
    
    _renderDocument(document) {
        return <React.Fragment key={document.id}>
            <DocumentItem parent={this} document={document} icon={faFileAlt} second_icon={(document.secured == 't' && faLock)} backgroundColor={styles['background-color-light-blue-10']} color={styles['color-light-blue']} borderColor={styles['border-color-light-blue']} />
            {(this.state.show_document_dialog && <DocumentDialog document={this.state.selected_document} parent={this} />)}
        </React.Fragment>
    }
    
    render(){
        //collapsedHeight = fontsize (bv 17) * lineheight(bv 1.5) * 3 (aantal lineclamp) (= bv 77)
        let content = <>
            <Text className={[styles['text-light'], (!this.state.show_more && styles['instruction-text'])]}>{_.nl2br(this.props.content)}</Text>
            {!_.is_empty(this.props.documents) && <>
                <View className={[styles['my-2'], styles['bb-1'], styles['border-color-light-grey']]} />
                {_.map(this.props.documents, this._renderDocument)}
            </>}
        </>;
        
        return(
        <>
            <View className={['mt-3 mt-lg-4', ...(this.props.className || []), styles['background-color-orange-10'], styles['instructions']]}>
                <Text className={[styles['text-light-bold']]}>Instructies</Text>
                {(_.is_empty(this.props.content) ?
                    <Text className={[styles['text-light']]}>Er zijn geen instructies beschikbaar</Text> 
                :
                    (this.props.content.length >= 450) 
                ? 
                <>
                    <Collapse in={this.state.show_more_animation} collapsedHeight={this.props.collapsedHeight} onExited={() => this.setState({show_more: false})} timeout={'auto'}>{content}</Collapse>
                    <TouchableArea className={[styles['mt-1-5']]} onPress={this._toggle_animation}>
                        <Text className={[styles['color-orange']]}>{(this.state.show_more_animation ? 'Lees minder' : 'Lees meer')}</Text>
                    </TouchableArea>
                </>
                : content)}
            </View>
        </>
        )   
    }
}
InstructionBox.defaultProps ={
    collapsedHeight:66, 
    className:['p-3', styles['f-1-7-5']],
}
export class Timeline extends React.Component {
    _openUrl(e, url) {
        window.open(url, '_blank');
    }
    
    render() {
        return _.map(this.props.timeline, (item, index) => {  
            let time    = item.time.format('D MMM YYYY [-] HH:mm');
            let isLast  = false;

            if(this.props.timeline.length - 1 == index)
                isLast = true;

            return <View key={'timeline-item-' + index}>
                <View className={['row d-flex']}>
                    <View className={['col-1 ml-2 px-0']}>
                        <View className={['d-flex pt-4 mb-4 justify-content-center']}>
                            <View>
                                <View className={[styles['time-line-dot'], styles['b-3'], styles['border-color-white'], styles['border-radius-100'], styles['background-color-light-blue']]}></View>
                                {!isLast && <View className={[styles['time-line-line'], styles['bl-1'], styles['border-color-grey-10'], styles['position-absolute']]}></View>}
                            </View>
                        </View>
                    </View>
                    <View className={['col mr-2 mr-md-0']}>
                        <View className={['d-flex py-3 px-3 px-md-2 flex-column',  (!item.url ? 'mb-4' : styles['bb-0']), styles['background-color-light-grey-10'], styles['b-1'], styles['border-color-light-grey']]}>
                            <View className={['d-flex flex-row justify-content-between']}>
                                <Text className={[styles['mb-0-2-5'], styles['f-1-7-5']]}>{time}</Text>
                                {item.actions && <Menu items={item.actions}>
                                    <FontAwesomeIcon icon={faEllipsisV} className={styles['f-3']} />
                                </Menu>}
                            </View>
                            <Text className={[styles['f-1-5'], styles['color-dark-grey'], styles['text-light']]}>{_.nl2br(item.title)}</Text>
                        </View>
                    </View>
                </View>
                {item.url && <View className={['row']}>
                    <View className={['col-1 ml-2 px-0 pt-4']}>
                        {!isLast && <View className={[styles['time-line-line'], styles['bl-1'], styles['border-color-grey-10'], styles['position-absolute']]}></View>}
                    </View>
                    <TouchableArea className={['col mr-2 mr-md-0 mb-4']} {...(item.click_url && { onPress: this._openUrl, onPressParams: item.click_url })}><Image style={{width: '100%', height: 115}} source={item.url} className={[styles['b-1'], styles['border-color-light-grey']]} resizeMode={'cover'} /></TouchableArea>
                </View>}
            </View>;
        });
    }
}

export class PlanningItem extends React.Component {
    render() {
        return <View className={['px-3 py-1 d-inline-flex flex-row', ...this.props.className]} {...(this.props.color ? {style: {backgroundColor: this.props.color}} : {})}>
            <View className={['ml-n3 my-n1 mr-2', styles['flex-1'], styles['planning-item-border']]} />
            <View className={[styles['text-ellipsis']]}>
                <Text className={[styles['text-regular'], styles['f-1-5'], styles['text-ellipsis']]}>{this.props.title}</Text>
                {this.props.time && <Text className={[styles['text-light'], styles['f-1-2-5']]}>{this.props.time}</Text>}
            </View>
        </View>;
    }
}
PlanningItem.defaultProps ={
    className:[],
}

export class TimeBlock extends CustomComponent {
    render() {
        return <View className={['rounded-sm px-1 py-2 align-items-center justify-content-center d-inline-flex', styles['background-color-' + this.props.color], styles['timeblock'], ...(this.props.className || [])]}><Text className={[styles['color-white'], styles['text-light-bold'], styles['f-0-7-5']]}>{this.props.children}</Text></View>;
    }
}


export class TabBlock extends CustomComponent {
    _renderRow(row, index) {
        return (
            <View className={['d-flex flex-row align-items-start px-2', styles['py-1-5'], styles['bt-1'], styles['border-color-light-grey']]} key={index}>
                {row.icon && <View className={[styles['line-height-2']]}><FontAwesomeIcon icon={row.icon} className={[styles['color-light-blue'], styles['f-1-5'], styles['fa-square']].join(' ')} /></View>}
                <View className={['d-flex flex-column' + (row.icon ? ' pl-3' : ''), styles['flex-1'], styles['line-height-2']]}>
                    {row.title && <Text className={[...(row.icon ? [] : ['mb-2']), ...(row.titleClass ? row.titleClass : [styles['f-1-5'], styles['color-dark-grey']])]}>{row.title}</Text>}
                    {row.content && <View className={[...(row.contentClass ? row.contentClass : [])]}>{row.content}</View>}
                </View>
            </View>
        );
    }
    
    render() {
        return (
            <View className={['d-flex flex-column pl-3 pr-2 pt-3 pb-1', styles['background-color-light-grey-10'], styles['b-1'], styles['border-color-light-grey'], ...(this.props.className || [])]}>
                {this.props.ribbon && (
                    <View className={['d-flex mt-n3 justify-content-center']}>
                        <Ribbon {...{ position: 'top', ...this.props.ribbon }} />
                    </View>
                )}
                <View className={['d-flex flex-row align-items-center', styles['mb-1-5']]}>
                    <View className={['d-flex flex-row align-items-center', styles['flex-1']]}>
                        <UserBlock {...{ size: 'small', ...this.props }} />
                        {this.props.description && (React.isValidElement(this.props.description) ? this.props.description : <Text className={['ml-2']}>{this.props.description}</Text>)}
                    </View>
                    {this.props.model_actions && <EditMenu {...{ id: this.props.id, actions: this.props.model_actions, ...this.props.edit_menu }} />}
                </View>
                {_.map(this.props.rows, this._renderRow)}
                {this.props.bottom_section}
            </View>
        );
    }
}

export class Timer extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {minutes: moment().diff(props.date_time, 'minutes')};
    }
    
    componentDidMount() {
        this.interval = setInterval(() => {
            let diff_in_minutes = moment().diff(this.props.date_time, 'minutes');

            if(this.state.minutes != diff_in_minutes)
                this.setState({minutes: diff_in_minutes});
        },1000);
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        // Als we bijvoorbeeld overgaan naar een nieuwe status
        if(prevProps.date_time != this.props.date_time)
            this.setState({minutes: moment().diff(this.props.date_time, 'minutes')});
    }
    
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    
    render() {
        let text = [this.state.minutes];
        
        if(!this.props.hideMinuteText)
            text.push(_.plural({amount: this.state.minutes, singular: 'minuut', plural: 'minuten'}));
        
        if(this.props.title)
            text.push(this.props.title);
        
        return text.join(' ');
    }
}

export function AttachmentItem({ attachment, component, preview, field, invert = false })
{
    const file = attachment.file ? attachment.file : attachment.evidence ? attachment.evidence : attachment.document;
    
    return (
        <View className={[styles['attachment-item-container']]}>
    		<Link href={Config.IMAGES_URL + 'file-' + component + '-' + attachment.id + (!_.is_empty(field) ? '-' + field : '') + '.' + _.get_file_extension(file)} target={'_blank'}>
    			<View className={['d-flex justify-content-center align-items-center mb-2', styles['attachment-item-icon'], (invert ? styles['invert'] : ''), styles['b-1'], styles['color-light-blue'], styles['f-5'], (invert ? styles['border-color-white'] : styles['border-color-grey-10'])]}>
    				{preview ? <Image source={Config.IMAGES_URL + 'file-' + component + '-' + attachment.id + '.' + _.get_file_extension(file)} resizeMode={'contain'} className={[styles['flex-1'], styles['w-100'], styles['h-100'], styles['attachment-item-preview']].join(' ')} /> : <FontAwesomeIcon icon={faCloudDownloadAlt} />}
    			</View>
    		</Link>
    		<Text className={['text-break d-flex justify-content-center', styles['f-1-2-5']]}>{attachment.title}</Text>
    	</View>
    );
}

export class OverviewSecurityCard extends CustomComponent {
    render() {
        let request_date;
        let remaining_date;
        
        const background_color    = {'Grijs' : 'grey', 'Groen' : 'green', 'Blauw (ESO)' : 'dark-blue', 'Blauw (Horeca)' : 'dark-blue', 'Oranje' : 'dark-orange', 'VKR' : 'purple'}; 
        const state_color         = {'Concept' : 'mint-blue', 'Aangevraagd' : 'orange', 'Goedgekeurd' : 'light-green', 'Verlopen' : 'red-pink'}; 
        let day_color 		    = 'black';
        const remaining 		    = this.props.values.remaining;
        const today               = moment();
        
        if (this.props.values.state === 'Aangevraagd')
            request_date = _.get_date_format(this.props.values.request_date);
        else if (this.props.values.state !== 'Concept' && remaining <= 0)
            this.props.values.state = 'Verlopen';
        else
		{   
		  
            if (this.props.values.start_date && moment(this.props.values.start_date).isAfter(today))
                remaining_date =  'per ' + _.get_date_format(this.props.values.start_date);
            else
                remaining_date = remaining + ' ' + _.plural({ singular: 'dag', plural: 'dagen', amount: remaining });    
		    
            if (remaining <= 30)
                day_color = 'red-pink';
            else if (remaining <= 60)
                day_color = 'orange';
        }
        
        return (
            <View className={[styles['background-color-' + background_color[this.props.values.type]], styles['b-r-20-px'],  'pl-2 m-1']}>
                <View className={[styles['b-r-20-px'], styles['background-color-white'], styles['b-1'], styles['border-color-grey']]}>
                    <View className={['m-2']}>
                        <Text className={[styles['color-' + state_color[this.props.values.state]], styles['text-regular'], styles['f-1-5']]} >{remaining >= 0 ?  this.props.values.state : 'Verlopen'}</Text>
                        <Text>{request_date ? <><FontAwesomeIcon icon={faCalendarDay} className={['mr-1']}/>{request_date}</> : null}</Text>
                        <Text  className={[styles['text-regular'], styles['color-' + day_color]]} >{remaining_date && this.props.values.state == 'Goedgekeurd' ? remaining_date : null}</Text>
                        <Text>{this.props.values.company}</Text>
                    </View>
                </View>
            </View>
        );
    }
}

export class SecurityCard extends CustomComponent {
    render() {
        const background_color    = {'Grijs' : 'grey', 'Groen' : 'green', 'Blauw (ESO)' : 'dark-blue', 'Blauw (Horeca)' : 'dark-blue', 'Oranje' : 'dark-orange', 'VKR' : 'purple'}; 
        const ribbon_color        = {'Concept' : 'mint-blue', 'Aangevraagd' : 'orange', 'Goedgekeurd' : 'light-green', 'Binnenkort actief': 'yellow'}; 
        const pass_title          = {'Grijs' : 'Grijze pas', 'Groen' : 'Groene pas', 'Blauw (ESO)' : 'Blauwe pas (ESO)', 'Blauw (Horeca)' : 'Blauwe pas (Horeca)', 'Oranje' : 'Oranje pas', 'VKR' : 'VKR pas'};
        const now                 = moment().format('YYYY-MM-DD');
        const state               = (this.props.state == 'Goedgekeurd' && this.props.start_date > now ? 'Binnenkort actief' : this.props.state);
        
        return <View className={[styles['background-color-' + background_color[this.props.type]], styles['b-r-20-px'], 'pb-1 mb-4']}>
            <View className={[styles['b-r-20-px'], ' bg-white border']}>
                <View className={['pb-3 pt-3']}>
                    <View className={['row justify-content-center align-items-center']}>
                        <View className={[styles['background-color-light-grey-10'], styles['b-r-20-px'], styles['small-rectangle'], 'align-items-center']}/>
                    </View>
                    <View className={['px-2 d-flex flex-row justify-content-between mt-2 mx-1 mx-lg-3']}>
                        <View>
                            <Text className={[styles['color-black'], styles['f-1-7-5'], styles['line-height-1-5']]}>{this.props.user.title}</Text>
                            <Text className={[styles['text-light'], styles['color-dark-grey'] , styles['f-1-5']]}>{this.props.company_name}</Text>
                        </View>
                        <View className={['d-flex flex-row']}>
                            {this.props.primaryButton && <View className={['d-none d-lg-flex justify-content-center align-items-center']}>
                                <Button {...this.props.primaryButton}>{this.props.primaryButton.title}</Button>
                            </View>}
                            {this.props.model_actions && <>
                                <View className={['d-none d-lg-flex justify-content-center align-items-center']}>
                                    <EditMenu id={this.props.id} actions={this.props.model_actions} onRemove={this.props.onRemove} {...(_.is_empty(this.props.downloadButtons) ? {} : {extraItems: this.props.downloadButtons})}/>
                                </View>
                                <View className={['d-flex d-lg-none justify-content-center align-items-center']}>
                                    <EditMenu id={this.props.id} actions={this.props.model_actions} onRemove={this.props.onRemove} {...(_.is_empty(this.props.primaryButton) ? {} : {extraItems: [this.props.primaryButton]})}/>
                                </View>
                            </>}
                        </View>
                    </View>
                    <View className={['mt-3 mb-2']}>
                        {this.props.end_date < now ? <Ribbon title='Verlopen' color={'red-pink'} /> : <Ribbon title={state} color={ribbon_color[state]} />}
                    </View>
                    <View className={['d-flex flex-row px-2 justify-content-between mx-1 mx-lg-3']}>
                        <View className={['mt-4']}>
                            {this.props.state === 'Goedgekeurd' || this.props.state === 'Aangevraagd' ? (
                                <>
                                    <Text className={[styles['color-black'], styles['f-1-7-5'], styles['line-height-1 -5']]}>
                                        <FontAwesomeIcon icon={faCalendarDay} className={[styles['f-3'], 'mr-2']}/>
                                        {
                                            this.props.state === 'Goedgekeurd' ? (
                                                moment(this.props.start_date).isValid() && moment(this.props.end_date).isValid() ? 
                                                    moment(this.props.start_date).format('D MMMM YYYY') + ' - ' + moment(this.props.end_date).format('D MMMM YYYY') 
                                                    : ''
                                            ) : (
                                                moment(this.props.request_date).format('D MMMM YYYY - HH:mm')
                                            )
                                        }
                                    
                                    </Text>
                                    <View className={[styles['bb-2'], styles['border-color-light-grey'], 'mt-2 mb-2']}></View>
                                    <Text className={[styles['color-black'], styles['f-1-7-5'], styles['line-height-1-5']]}>
                                        <FontAwesomeIcon icon={faInfoCircle} className={[styles['f-3'], 'mr-2']}/>
                                        {this.props.state === 'Goedgekeurd' ? this.props.pass_number : this.props.user_name}
                                    </Text>
                                </>
                            ) : null}
                        </View>
                        <View>
                            <View>
                                {getUserPicture(this.props.user, this.props.size)}
                            </View>
                        </View>
                    </View>
                </View>
            </View>
            <View className={[styles['text-light'], styles['f-1-2-5'], styles['line-height-0-7-5'], 'text-white pl-3 ml-1 mt-1']}>
                {pass_title[this.props.type]}
            </View>
        </View>
    }
}

export class FormNumber extends CustomComponent {
    render() {
        return <Text className={[styles['f-1-2-5'], styles['border-radius-100'], styles['color-white'], styles['background-color-light-blue'], styles['form-number'], 'd-flex justify-content-center']}>
            {this.props.index + 1}
        </Text>;
    }
}

export class RoutePhone extends CustomComponent {
    _openForm() {
        this.props.history.push('/form/' + this.props.id);
    }
    
    _remove() {
        let model = new Model({ controller: this.props.controller, name: Components.__ROUTE_PHONE_COMPONENT__, data: { id: this.props.id } });
        
        model.remove();
        model.save();
    }

    render() {
        let actions = [];
        
        if(this.props.model_actions)
        {
            if(this.props.model_actions.commit)
                actions.push({ title: 'Wijzig', onPress: this._openForm, secondary: true });
            
            if(this.props.model_actions.remove)
                actions.push({ title: <FontAwesomeIcon icon={faTrash} className={[styles['color-red-pink']]} />, onPress: this._remove, secondary: true, color: 'red-pink', px: '1-5', ...(!_.is_empty(actions) && { className: ['ml-2'] }), confirmMessage: 'Weet je zeker dat je deze telefoon wilt ontkoppelen' });
        }
        
        return (
            <Image className={['d-inline-flex flex-column align-items-center mt-4 mx-3 pt-5', styles['route-phone']]} source={Config.GLOBAL_IMAGES_URL + 'route-phone/phone_' + (this.props.highlighted ? 'highlighted' : 'background') + '.png'}>
                <View className={['rounded-circle', styles['center-children'], styles['background-color-light-blue-10'], styles['route-phone-icon']]}>
                    <FontAwesomeIcon icon={this.props.icon} className={[styles['f-3-5'], styles['color-light-blue']]} />
                </View>
                {this.props.route && <Text className={['mt-3', styles['f-1-5']]}>{this.props.route}</Text>}
                {this.props.employee_display_name && <Text className={['w-100 px-3 text-center', styles['f-1-2-5'], styles['text-light'], styles['text-ellipsis']]}>{this.props.employee_display_name}</Text>}
                {(this.props.show_ribbon && _.is_empty(this.props.device_id)) && <Ribbon title="Concept" color="orange" className={['align-self-start mt-3']} />}
                {!_.is_empty(actions) && <View className={['mt-5 pt-' + (_.is_empty(this.props.device_id) ? '2' : '5')]}><ButtonGroup buttons={actions} breakpoint={false} /></View>}
            </Image>
        );
    }
}
RoutePhone.defaultProps = { icon: faCar, show_ribbon: true };

export class Stepper extends CustomComponent {
    render() {
        const steps_array = [];
        
        for(let i = 0; i < this.props.steps; i++){
            const last_step = i == this.props.steps - 1;
            
            steps_array.push(<React.Fragment key={i}>
                {!last_step ? (
                    <>
                        <Step active={this.props.current_step == i}>{i + 1}</Step>
                        <View className={['mx-2 mx-md-0 my-md-2 py-3', styles['bt-1'], styles['bt-md-0'], styles['bl-md-1'], styles['border-color-light-blue'], styles['border']]} /> 
                    </>
                ) : (
                    <Step active={this.props.current_step == i}>
                        <FontAwesomeIcon icon={faCheck} />
                    </Step>
                )}
            </React.Fragment>);
        }
        
        return (
            <View className={['d-flex flex-column flex-md-row']}>
                <View className={['d-flex flex-row flex-md-column px-2 px-md-5 py-4 py-md-5', styles['center-children'], styles['background-color-light-blue-5'], styles['b-1'], styles['bb-0'], styles['bb-md-1'], styles['br-md-0'], styles['border-color-light-grey']]}>
                    {steps_array}
                </View>
                <View className={['d-flex', styles['w-100']]}>
                    {this.props.children}
                </View>
            </View>
        );
    }
}

class Step extends CustomComponent {
    render() {
        return (
            <View style={{width: '50px', height: '50px', borderRadius: '50%'}} className={['d-flex justify-content-center align-items-center', styles['f-1-7-5'], styles['background-color-light-blue' + (this.props.active ? '' : '-10')], styles['color-' + (this.props.active ? 'white' : 'light-blue')]]}>
                {this.props.children}
            </View>
        );
    }
}

export class Divider extends CustomComponent {
    render() {
        return (
            <View className={[styles['bt-1'], styles['border-color-' + this.props.color], this.props.margin ? this.props.margin : {}]} />
        );
    }
}

Divider.defaultProps = {
    color: 'light-grey',
    margin: 'my-4'
}

export class CustomMapMarker extends React.Component {
    render() {
        return <View className={['rounded-circle', styles['center-children'], styles['b-1'], styles['border-color-blue'], styles['background-color-light-blue'], styles['marker']]}>{this.props.children}</View>;
    }
}